import { BrowserView, isMobileOnly, MobileView } from 'react-device-detect'
import { Col, Row } from 'react-bootstrap'
import { Parallax } from 'react-scroll-parallax'
import { useNavigate } from 'react-router-dom'
import { Fade, Zoom } from 'react-awesome-reveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingHeart, faHandshake, faHandsHolding } from '@fortawesome/free-solid-svg-icons'
import Button from '../Utils/Button'
import '../../styles/Home/HomeInfo.css'
import homeInfo_1 from '../../assets/images/home/home-info-1.jpg'
import homeInfo_2 from '../../assets/images/home/home-info-2.jpg'
import homeInfo_3 from '../../assets/images/home/home-info-3.jpg'

function HomeInfo() {

    const navigate = useNavigate()

    return (

        <>
            <BrowserView>
                <div className='homeInfo'>
                    <Fade duration={500}>
                        <Parallax speed={20}>
                            <div className='homeInfoTitle'>
                                Au Vietnam, 5,5 millions de personnes vivent encore en dessous du seuil de pauvreté, dont 90 % en zones rurales.
                            </div>
                            <div className='homeInfoSubtitle'>
                                Malgré d’importants progrès économiques, la pauvreté touche encore massivement les minorités
                                ethniques. Rejoignez-nous pour améliorer les conditions de vie des plus pauvres, où l’accès à l’eau
                                potable, à l’éducation et aux soins de santé reste un défi quotidien.
                            </div>
                            <div className='homeInfoSource'>
                                source : actiononpoverty.org
                            </div>
                        </Parallax>
                    </Fade>
                    <div className='homeInfoCards'>
                        <Row>
                            <Col sm={4}>
                                <Zoom duration={500}>
                                    <div className='homeInfoCard'>
                                        <div className='homeInfoCardImage'>
                                            <img src={homeInfo_1} height={250} className='homeInfoCardImage' alt="homeInfo-1" />
                                        </div>
                                        <div className='homeInfoCardIconContainer'>
                                            <div className='homeInfoCardIconRound'>
                                                <FontAwesomeIcon icon={faHandHoldingHeart} className='homeInfoCardIcon' />
                                            </div>
                                        </div>
                                        <div className='homeInfoCardText'>Soutenir l'espoir</div>
                                        <Button theme={'dark'} text={"Donnez"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/donation') }} />
                                    </div>
                                </Zoom>
                            </Col>
                            <Col sm={4}>
                                <Zoom delay={200} duration={500}>
                                    <div className='homeInfoCard'>
                                        <div className='homeInfoCardImage'>
                                            <img src={homeInfo_2} height={250} className='homeInfoCardImage' alt="homeInfo-2" />
                                        </div>
                                        <div className='homeInfoCardIconContainer'>
                                            <div className='homeInfoCardIconRound'>
                                                <FontAwesomeIcon icon={faHandshake} className='homeInfoCardIcon' />
                                            </div>
                                        </div>
                                        <div className='homeInfoCardText'>Commencez à changer des vies</div>
                                        <Button theme={'dark'} text={"Impliquez vous"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/contactez-nous') }} />
                                    </div>
                                </Zoom>
                            </Col>
                            <Col sm={4}>
                                <Zoom delay={400} duration={500}>
                                    <div className='homeInfoCard'>
                                        <div className='homeInfoCardImage'>
                                            <img src={homeInfo_3} height={250} className='homeInfoCardImage3' alt="homeInfo-3" />
                                        </div>
                                        <div className='homeInfoCardIconContainer'>
                                            <div className='homeInfoCardIconRound'>
                                                <FontAwesomeIcon icon={faHandsHolding} className='homeInfoCardIcon' />
                                            </div>
                                        </div>
                                        <div className='homeInfoCardText'>Devenez bénévole</div>
                                        <Button theme={'dark'} text={"Rejoignez nous"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/à-propos') }} />
                                    </div>
                                </Zoom>
                            </Col>
                        </Row>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div className='homeInfo'>
                    <Fade delay={300}>
                        <Parallax speed={20}>
                            <div className='homeInfoTitleMobile'>
                                Au Vietnam, 5,5 millions de personnes vivent encore en dessous du seuil de pauvreté, dont 90 % en zones rurales.
                            </div>
                            <div className='homeInfoSubtitleMobile'>
                                Malgré d’importants progrès économiques, la pauvreté touche encore massivement les minorités
                                ethniques. Rejoignez-nous pour améliorer les conditions de vie des plus pauvres, où l’accès à l’eau
                                potable, à l’éducation et aux soins de santé reste un défi quotidien.
                            </div>
                            <div className='homeInfoSourceMobile'>
                                <a href="https://actiononpoverty.org/our-impact/where-we-work/vietnam/">source : <u>actiononpoverty.org</u></a>
                            </div>
                        </Parallax>
                    </Fade>
                    <Row>
                        <Col sm={12}>
                            <Zoom duration={500}>
                                <div className='homeInfoCardMobile'>
                                    <div className='homeInfoCardImage'>
                                        <img src={homeInfo_1} width={'80%'} className='homeInfoCardImage' alt="homeInfo-1" />
                                    </div>
                                    <div className='homeInfoCardIconContainer'>
                                        <div className='homeInfoCardIconRound'>
                                            <FontAwesomeIcon icon={faHandHoldingHeart} className='homeInfoCardIcon' />
                                        </div>
                                    </div>
                                    <div className='homeInfoCardText'>Soutenir l'espoir</div>
                                    <Button theme={'dark'} text={"Donnez"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/donation') }} />
                                </div>
                            </Zoom>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Zoom duration={500}>
                                <div className='homeInfoCardMobile'>
                                    <div className='homeInfoCardImage'>
                                        <img src={homeInfo_2} width={'80%'} className='homeInfoCardImage' alt="homeInfo-2" />
                                    </div>
                                    <div className='homeInfoCardIconContainer'>
                                        <div className='homeInfoCardIconRound'>
                                            <FontAwesomeIcon icon={faHandshake} className='homeInfoCardIcon' />
                                        </div>
                                    </div>
                                    <div className='homeInfoCardText'>Commencez à changer des vies</div>
                                    <Button theme={'dark'} text={"Impliquez vous"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/contactez-nous') }} />
                                </div>
                            </Zoom>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Zoom duration={500}>
                                <div className='homeInfoCardMobile'>
                                    <div className='homeInfoCardImage'>
                                        <img src={homeInfo_3} width={'80%'} className={isMobileOnly ? 'homeInfoCardImage3Mobile' : 'homeInfoCardImage3Tablet'} alt="homeInfo-3" />
                                    </div>
                                    <div className='homeInfoCardIconContainer'>
                                        <div className='homeInfoCardIconRound'>
                                            <FontAwesomeIcon icon={faHandsHolding} className='homeInfoCardIcon' />
                                        </div>
                                    </div>
                                    <div className='homeInfoCardText'>Devenez bénévole</div>
                                    <Button theme={'dark'} text={"Rejoignez nous"} rounded={true} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/à-propos') }} />
                                </div>
                            </Zoom>
                        </Col>
                    </Row>
                </div>
            </MobileView>
        </>

    )

}

export default HomeInfo
